module.exports = __webpack_public_path__ + "img/customer-confidence.657295ac.png";